export default "__VITE_ASSET__Brg2QKgY__"